import { UserRoutingModule } from './user-routing.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "src/app/app-routing.module";
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserLeftPanelComponent } from './components/user-left-panel/user-left-panel.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserMainPanelComponent } from './components/user-main-panel/user-main-panel.component';
import { UserParentListComponent } from './components/user-parent-list/user-parent-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { DeploymentModule } from '../deployment/deployment.module';
import { CoreModule } from 'src/app/core/core.module';
import { AddUserComponent } from './modals/add-user/add-user.component';
import { DeleteUserComponent } from './modals/delete-user/delete-user.component';
import { UpdateUserComponent } from './modals/update-user/update-user.component';
import { UserAccessControlComponent } from './components/user-access-control/user-access-control.component';
import { DetachDeploymentComponent } from './components/user-access-control/dialogs/detach-deployment/detach-deployment.component';
import { AttachDeploymentComponent } from './components/user-access-control/dialogs/attach-deployment/attach-deployment.component';
import { UpdateJobSubmitIdComponent } from './components/user-access-control/dialogs/update-job-submit-id/update-job-submit-id.component';
import { ResetPassConfirmationComponent } from './modals/reset-pass-confirmation/reset-pass-confirmation.component';
import { BulkAddUserComponent } from './modals/bulk-add-user/bulk-add-user.component';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { NotificationConfigurationComponent } from './modals/notification-configuration/notification-configuration.component';
import { SharedModule } from '../shared/shared.module';
import { NgbDropdown, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BillingInputComponent } from './modals/billing-input/billing-input.component';
import { BillingPreviewComponent } from './modals/billing-preview/billing-preview.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { DynamicPaginationDirective } from 'src/app/core/directive/dynamicPagination/dynamic-pagination.directive';
import { AngularSplitModule } from 'angular-split';
import { UserAdvanceViewComponent } from './components/user-advance-view/user-advance-view.component';
import { UserAccessControlModule } from './components/user-access-control/user-access-control.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    UserDetailsComponent,
    UserLeftPanelComponent,
    UserListComponent,
    UserMainPanelComponent,
    UserParentListComponent,
    AddUserComponent,
    DeleteUserComponent,
    UpdateUserComponent,
    ResetPassConfirmationComponent,
    BulkAddUserComponent,
    NotificationConfigurationComponent,
    BillingInputComponent,
    BillingPreviewComponent,
    UserAdvanceViewComponent,
  ],
  imports: [
    AppRoutingModule,
    UserRoutingModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    ResizableModule,
    SharedModule,
    NgbModule,
    NgMultiSelectDropDownModule,
    NgSelectModule,
    DynamicPaginationDirective,
    AngularSplitModule,
    UserAccessControlModule,
    NgbDropdownModule,
    MatTooltipModule
  ]
})
export class UserModule { }
